import React from 'react'
import { ContainerCard } from '../../../reusable-components/AgiliteCards'
import CustomRow from '../../../reusable-components/CustomRow'
import { Col } from 'antd'
import TreatmentPlansManagement from './TreatmentPlansManagement'

const TreatmentPlansWrapper = () => (
  <ContainerCard>
    <CustomRow>
      <Col span={24}>
        <TreatmentPlansManagement isMonitoring={false} />
      </Col>
    </CustomRow>
  </ContainerCard>
)

export default TreatmentPlansWrapper
